import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/src/app/(privacyAndTerms)/privacy-policy/page.tsx");
